import { useLocation } from 'react-router-dom';
import { getWorkspaceIdFromCurrentUrl } from '@/utils/workspace-id';

export function useWorkspaceIdFromCurrentUrl(): number | null {
  const location = useLocation();
  return getWorkspaceIdFromCurrentUrl(location.pathname);
}
